import React from "react";
import useSeverityAsPriority, {
  SeverityFieldsEnum,
} from "../../General/useSeverityAsPriority";
import PriorityTagDisplay from "./PriorityTagDisplay/PriorityTagDisplay";

interface PriorityTagProps {
  severity?: string | number;
  size?: string;
}

const PriorityTag: React.FC<PriorityTagProps> = ({ severity, size }) => {
  const { getSeverityField } = useSeverityAsPriority();

  return (
    <PriorityTagDisplay
      size={size}
      backgroundColor={getSeverityField(severity, SeverityFieldsEnum.COLOR)}
      color={getSeverityField(severity, SeverityFieldsEnum.TEXT_COLOR)}
      label={getSeverityField(severity, SeverityFieldsEnum.NAME)}
    />
  );
};

export default PriorityTag;
